<template>
    <div class="kbm-links">
        <v-layout row justify-center v-for="(value, key) in links" :key="key">
            <v-dialog maxWidth="600px">
                <template v-slot:activator="{ on }">
                    <a v-on="on">{{ value.linkText }}</a>
                </template>
                <v-card class="kbm-card">
                    <v-card-text v-html="value.bodyText"></v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>
<script>
    export default {
        data:() => ({
            links: [
                {
                    linkText: 'Об услуге',
                    bodyText: `
                        <p>КБМ – это скидочный коэффициент по полису ОСАГО, который присваивается за безаварийную езду. За каждый год безаварийной езды присваивается 5% скидки и так до 50%, если аварии в течение года происходили, то скидка наоборот уменьшается. Хорошая скидка по КБМ позволяет экономить на ОСАГО до половины стоимости полиса.</p>
                        <p>Иногда в результате ошибок или замены документов скидка по КБМ «теряется». Для таких случаев и предусмотрена функция «Восстановление КБМ». Мы собираем необходимые данные о ваших текущих и старых правах и передаем в РСА (Российский союз автостраховщиков) для восстановления утерянного КБМ.</p>
                        <p>Рассмотрение заявки занимает до 7 дней и по итогам рассмотрения КБМ либо восстанавливается, либо остается прежним. В случае, если КБМ остается прежним, мы возвращаем уплаченные вами денежные средства.</p>
                    `
                },
                {
                    linkText: 'Об оплате',
                    bodyText: `
                        <p>Способы оплаты:</p>
                        <p>Банковской картой<br>
                        Для выбора оплаты товара с помощью банковской карты на соответствующей странице необходимо нажать кнопку Восстановить КБМ за 150 руб. Оплата происходит через ПАО СБЕРБАНК с использованием банковских карт следующих платёжных систем:</p>
                        <p>МИР <img src='/img/payment/mir.png'><br>
                        VISA International <img src='/img/payment/visa.png'><br>
                        Mastercard Worldwide <img src='/img/payment/MasterCard.svg'><br>
                        JCB <img src='/img/payment/jcb.svg'></p>
                        <p>Для оплаты (ввода реквизитов Вашей карты) Вы будете перенаправлены на платёжный шлюз ПАО СБЕРБАНК. Соединение с платёжным шлюзом и передача информации осуществляется в защищённом режиме с использованием протокола шифрования SSL. В случае если Ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa, MasterCard SecureCode, MIR Accept, J-Secure, для проведения платежа также может потребоваться ввод специального пароля.</p>
                        <p>Настоящий сайт поддерживает 256-битное шифрование. Конфиденциальность сообщаемой персональной информации обеспечивается ПАО СБЕРБАНК. Введённая информация не будет предоставлена третьим лицам за исключением случаев, предусмотренных законодательством РФ. Проведение платежей по банковским картам осуществляется в строгом соответствии с требованиями платёжных систем МИР, Visa Int., MasterCard Europe Sprl, JCB.</p>
                    `
                },
                {
                    linkText: 'О возврате',
                    bodyText: `
                        <p>Возврат переведённых средств, производится на ваш банковский счёт в течение 5-30 рабочих дней (срок зависит от банка, который выдал вашу банковскую карту).</p>
                    `
                }
            ]
        })
    }
</script>
<style scoped>
    .kbm-links{
        padding: 25px 15px;
    }
    .kbm-links a{
        font-size: 18px;
        text-decoration: underline !important;
        margin: 5px 0;
        font-weight: bold;
    }
</style>
<style>
    .kbm-card .v-card__text p img{
        max-height: 15px;
        margin-top: -2px;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/elements/KbmLinks.vue